// extracted by mini-css-extract-plugin
module.exports = {"rules":"LeaderboardRules_rules__3PIo4","rule":"LeaderboardRules_rule__3rFHM","rulesPreview":"LeaderboardRules_rulesPreview__3PR3i","delete":"LeaderboardRules_delete__31lKp"};